import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Group, Matrix } from 'src/app/common-class/pages';
import { CommonLogic } from 'src/app/common-logic/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { PreviewData } from 'src/app/common-class/survey';
import { SurveyMessages } from 'src/app/common-class/survey-messages';
declare var $: any;

@Component({
  selector: 'app-multiple-drop-down',
  templateUrl: './multiple-drop-down.component.html',
  styleUrls: ['./multiple-drop-down.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultipleDropDownComponent implements OnInit {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() group: Group;
  @Input() matrix: Matrix;
  @Input() isMDD: boolean;
  @Input() isSubmitted: boolean;
  @Input() DropDown:string;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  firstQuestion:Questions;

  tempArray = [];
  questionsArray: any;

  mainQuestionWidth: any;
  subQuestionWidth: any;
  totalWidth: any;
  checkDrillDown: number = 0;
  prevValue: any;
  dropDownCount : number;
  dropDownlength : number;
  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean = false;
  isSearchableDD: boolean = false;
  isPreReadQn: boolean;
  resetPageSub: any;
  isNgOnChange: boolean;
  ngCount: number = 0;
  isAnswerPipingSubChar: boolean;
  isDisplayedPipeMessage: boolean;
  MDDdropDownCount : number;
  Nomatchfound: string;
  surveyMessages: SurveyMessages;
  isAnySubQMandatory:boolean

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    if (change != undefined && change != null) {
      let curVal = JSON.stringify(change.currentValue);
      let preVal = JSON.stringify(change.previousValue);

      if (curVal != preVal && preVal != undefined) {
        //this.questions = JSON.parse(this.JsonData);

        this.objectLoading();

        if (this.questions.length > 0) {
          this.isNgOnChange = true;
          this.ngCount = 1;

          if (this.matrix.MultiColumnCount > 1) {
            this.HorizontalHandling();
          }

          if (!this.isMDD) {
            for (let i = 0; i < this.questions.length; i++) {
              if (this.questions[i].selectAnsValue == undefined) {
                this.questions[i].selectAnsValue = -1;
              }

              if (this.isAnswerPipingSubChar) {
                this.questions[i].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1)
              }

              if (this.questions[i].answer_style == 2) {
                this.questions[i].Answers = CommonLogic.RandomAnswerHandling(this.questions[i]);
              }
            }
            if (this.group.answer_style == 2) {
              this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
            }
          }

          if (this.isMDD) {

            if (this.group.answer_style == 1 && this.isMDD) {
              this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
            }
            else if(this.group.answer_style == 0 && this.questions.length > 1)
            {
             this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
            }
            else if(this.group.answer_style == 2 && this.questions[0].grpRotateIndex != -1 && this.questions.length > 1)
            {
              this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
              CommonLogic.RotateQuestionsHandling(this.questions);
            }

            this.ngAfterViewInit();
          }
        }
      }
    }
  }

  constructor(private service: ParticipationDataService, private previewData: PreviewData,
    private changeDetect: ChangeDetectorRef) {
  }

  ngOnInit() {
    if (this.questions == null) {
      this.surveyMessages= this.service.getSurveyMessages();
      //this.questions = JSON.parse(this.JsonData);

      this.objectLoading();

      if (this.questions.length > 0) {
        this.MDDdropDownCount = this.service.getMDDdropDownCount();
        this.Nomatchfound= this.service.getSurveyMessages().Participation_Nomatchfound;
        if (this.questions.filter(e => e.Answers.length > (this.MDDdropDownCount-1)).length > 0) {
          this.isSearchableDD = true;
        }

        // let fstQn = this.questions[0];
        // if (fstQn != undefined && fstQn != null) {
        //   this.firstQuestion = fstQn;
        // }
        // let imgQn = this.questions.find(e => e.sub_qno == 1);
        // if (imgQn != undefined && imgQn != null) {
        //   this.imgQuestion = imgQn;
        // }

        if (this.group.answer_style == 1 && this.isMDD) {
          this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
        }
        else if(this.group.answer_style == 0 && this.questions.length > 1)
        {
         this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
        }
        else if(this.group.answer_style == 2 && this.questions[0].grpRotateIndex != -1 && this.questions.length > 1)
        {
          this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
          CommonLogic.RotateQuestionsHandling(this.questions);
        }

        if (this.matrix.MultiColumnCount > 1) {
          this.HorizontalHandling();
        }

        //this.setRddColWidth();



        if (!this.isMDD) {
          for (let i = 0; i < this.questions.length; i++) {
            if (this.questions[i].selectAnsValue == undefined) {
              this.questions[i].selectAnsValue = -1;
            }

            if (this.isAnswerPipingSubChar) {
              this.questions[i].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1)
            }


            if (this.questions[i].answer_style == 2) {
              this.questions[i].Answers = CommonLogic.RandomAnswerHandling(this.questions[i]);
            }
            // $('.drill-down-list-itemMessage_'+this.questions[i].UniqueNumber).hide();
          }

          if (this.group.answer_style == 2) {
            this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
          }
        }

        if(this.questions.filter(e=>e.mandatory)!=undefined && this.questions.filter(e=>e.mandatory).length > 0)
        {
          this.isAnySubQMandatory=true;
        }

        this.isNewParticipation = this.service.isNewParticipation;
        this.surveyFormat = this.service.surveyFormat;
        this.dropDownCount = this.service.getdropDownCount();
        this.MDDdropDownCount = this.service.getMDDdropDownCount();
        this.dropDownlength = this.questions.length;
        this.newParticipationBtnText = this.service.newParticipationBtnText;
        this.showNewParticipationButton = (this.questions.length > 1 || !this.service.isAutoScroll) && this.isNewParticipationButton;
        this.isPreReadQn = this.questions.filter(e => e.population_type == 3).length > 0;
      }
    }
  }

  objectLoading() {
    this.questions = JSON.parse(this.JsonData);

    let fstQn = this.questions[0];
    if (fstQn != undefined && fstQn != null) {
      this.firstQuestion = fstQn;
    }

    let imgQn = this.questions.find(e => e.sub_qno == 1);
    if (imgQn != undefined && imgQn != null) {
      this.imgQuestion = imgQn;
    }

    if (this.previewData != undefined && this.previewData.isPrevPgChnge &&
      this.questions[0].AnsPipeCondition != 0 && this.questions[0].AnsPipeCondition != 1 &&
      this.questions[0].AnsPipeCondition != 3 && this.questions[0].AnsPipeCondition != 4 &&
      this.questions.find(e => e.isMultiQuestionPiping) == undefined) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }

    if (this.questions.find(e => e.AnsPipeCondition > 1) != undefined && this.isDisplayQno) {
      this.isAnswerPipingSubChar = true;
    } else {
      this.isAnswerPipingSubChar = false;
    }

    this.questions = this.questions.filter(e => !e.isMultiQuestionPiping);
  }

  UpdateQuestionsData(question: Questions) {
    this.isAnsChange = true;
    this.ChangeAnswersData.emit(question);
  }

  HorizontalHandling() {
    let DispAnsCol = this.matrix.MultiColumnCount;
    let nonHiddenQs = this.questions.filter( e => e.isCQHide == false && e.population_type !=2 && e.population_type != 5);
    let answerLength = nonHiddenQs.length;
    let rowCount = Math.ceil(answerLength / DispAnsCol);

    //Horizontal
    let ansArray = [];

    for (let i = 0; i < rowCount; i++) {
      let tempArray = [];
      let counter = 0;
      //let index = 0;
      for (let j = (i * DispAnsCol); j < answerLength; j++) {
        counter++;
        tempArray.push(nonHiddenQs[j]);

        if (counter == DispAnsCol) {
          break;
        }
      }

      ansArray.push(tempArray);
    }

    this.tempArray[0] = ansArray;
    this.questionsArray = this.tempArray;
  }

  GetQuestionsString(question): string {
    return JSON.stringify(question);
  }

  ngAfterViewInit() {
    if(window.navigator.userAgent.indexOf("Chrome") != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
      // $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    }

    if (this.questions.length == 0) {
      return;
    }

    var self = this;
    if(self.isSearchableDD)
        {
          let elemid = 'Q' + self.firstQuestion.qno + '_' + self.firstQuestion.UniqueNumber + '_RW';
          $('#'+elemid).find('.answer-option-wrapper').css('padding-bottom','70px');
          $('#'+elemid).find('.answer-option-wrapper').addClass('GridSearch');
        }
    if(this.isMDD){
      setTimeout(() => {
        let elemid = 'Q' + self.firstQuestion.qno + '_' + self.firstQuestion.UniqueNumber + '_RW';
        $('.mdd-wrapper').each(function (i) {
          $(this).find('.question-option-wrapper').addClass('subqtn');
        });
        var arr = [];
        $('#' + elemid).each(function (i) {
          if($(this).find('.mdd-wrapper').hasClass('singleCol')) {
            setTimeout(() => {
            $(this).find('.mdd-wrapper.singleCol .question-option-wrapper.subqtn').each(function (j) {
              $(this).find('.question-text').css('white-space','nowrap');
              arr[j] = $(this).outerWidth();
            });
            var max = Math.max(...arr);
            if(max > 350){
              max = 350;
            }
            if(max < 25)
            {
                max=25;
            }
            else
            {
              max= (max + 10);
            }

              $(this).find('.mdd-wrapper.singleCol .question-option-wrapper.subqtn').css('width', max + 'px');
              $(this).find('.mdd-wrapper.singleCol .question-option-wrapper.subqtn').css('min-width', max + 'px');
              $(this).find('.mdd-wrapper.singleCol .question-text').css('white-space', 'normal');
            }, 50);
          } else {
            /*Multiple columns width calculations*/
            var i, j, totallen = 0;
            $(this).find('.question-text').css('white-space', 'nowrap');
            var rowLen = $(this).find('.column-struct-mdd').find('table tr').length;
            var colLen = $(this).find('.column-struct-mdd').find('table tr:first-child td').length;
            var lengthArr = [];
            if(colLen == 2) {
              lengthArr = [0,0];
            } else {
              lengthArr = [0,0,0];
            }
            for(i=0; i< colLen; i++) {
              for(j=0 ; j < rowLen; j++) {
                if($(this).find('.column-struct-mdd').find('table tr').eq(j).find('td').eq(i).find('.question-option-wrapper.subqtn').outerWidth() == undefined) {
                  //lengthArr.push(0);
                } else {
                  if(lengthArr[i] < ($(this).find('.column-struct-mdd').find('table tr').eq(j).find('td').eq(i).find('.question-option-wrapper.subqtn').outerWidth())) {
                    lengthArr[i] = $(this).find('.column-struct-mdd').find('table tr').eq(j).find('td').eq(i).find('.question-option-wrapper.subqtn').outerWidth();
                  }
                }
              }
              if(lengthArr[i] > 450) {
                lengthArr[i] = 450;
              }
            }

            for (i = 0; i < lengthArr.length; i++) {
              totallen = totallen + lengthArr[i];
            }


            $(this).find('.column-struct-mdd').find('table').css('width', totallen + 'px');

            for (i = 0; i < rowLen; i++) {
              for (j = 0; j < colLen; j++) {
                $(this).find('.column-struct-mdd').find('table tr').eq(i).find('td').eq(j).find('.question-option-wrapper.subqtn').css('width', lengthArr[j] + 'px');
                $(this).find('.column-struct-mdd').find('table tr').eq(i).find('td').eq(j).find('.question-option-wrapper.subqtn').css('min-width', lengthArr[j] + 'px');
                $(this).find('.column-struct-mdd').find('table tr').eq(i).find('td').eq(j).find('.question-option-wrapper.subqtn').css('max-width', '450px');
                $(this).find('.column-struct-mdd').find('table tr').eq(i).find('td').eq(j).find('.question-option-wrapper.subqtn .question-text').css({'max-width' : '430px'});
                $(this).find('.column-struct-mdd').find('table tr').eq(i).find('td').eq(j).find('.question-option-wrapper.subqtn .question-text span').css({'display': 'inline-block', 'vertical-align': 'top', 'max-width' : '400px'});
              }
            }

            $(this).find('.question-text').css('white-space', 'normal');
          }
        });
      }, 50);

      if(self.matrix.MultiColumnCount > 1)
      {
      setTimeout(() => {
        let elemid = '#dv_' + self.firstQuestion.UniqueNumber;
        if ($(elemid).find('.answer-option-wrapper').outerWidth() > $(elemid).outerWidth()) {
          $(elemid).find('.div-scroll-btn').show();
        }
      }, 0);


    $(document).ready(function () {
      let elemid = '#dv_' + self.firstQuestion.UniqueNumber;
      if(self.isSearchableDD)
      {
        $(elemid).find('.answer-option-wrapper').css('padding-bottom','70px');
        $(elemid).find('.answer-option-wrapper').addClass('GridSearch');
      }

      $('.fieldset-wrapper-scroll').scroll(function () {
        if($('.RTLDir').length > 0) {
          if ($(this).scrollLeft() == 0) {
            $(this).parents('.divScroll').find('.div-scroll-btn').hide();
          } else {
            $(elemid).parents('.divScroll').find('.div-scroll-btn').show();
          }
        } else {
          if ($(this).find('.answer-option-wrapper').outerWidth() - $(this).scrollLeft() <= $(this).outerWidth() + 5) {
            $(this).parents('.divScroll').find('.div-scroll-btn').hide();
          } else {
            $(this).parents('.divScroll').find('.div-scroll-btn').show();
          }
        }
      });
    });
  }

    } else {
      this.setRddColWidth();
    }

    $(window).resize(function() {
      self.setRddColWidth();
    });

    // $(document).click(function () {
    //   if (!$(event.target).parents().hasClass('drill-down-search')) {
    //     $('.drill-down-search').removeClass('showDrillList');
    //   }
    // });

      $('document').ready(function () {

        for (let i = 0; i < self.questions.length; i++) {
          if($('#dv_RDDG_' + self.questions[i].UniqueNumber).find('input.drill-down-input-'+ self.questions[i].UniqueNumber)){
            if($('#dv_RDDG_' + self.questions[i].UniqueNumber).find('input.drill-down-input-'+ self.questions[i].UniqueNumber).val() == "") {
              $('#dv_RDDG_' + self.questions[i].UniqueNumber).find('input.drill-down-input-'+ self.questions[i].UniqueNumber).removeClass('no-search-icon');
            } else {
              $('#dv_RDDG_' + self.questions[i].UniqueNumber).find('input.drill-down-input-'+ self.questions[i].UniqueNumber).addClass('no-search-icon');
            }
          }else{
            if($('#dv_' + self.questions[i].UniqueNumber).find('input.drill-down-input').val() == "") {
              $('#dv_' + self.questions[i].UniqueNumber).find('input.drill-down-input').removeClass('no-search-icon');
            } else {
              $('#dv_' + self.questions[i].UniqueNumber).find('input.drill-down-input').addClass('no-search-icon');
            }
          }
        }
      });

    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange =false;
      }
    });


    if (self.questions != null) {
      if (self.questions.length > 0) {
        if (!this.isMDD) {
          for (let i = 0; i < self.questions.length; i++) {
            $('.drill-down-list-itemMessage_'+self.questions[i].UniqueNumber).hide();
            let width=$('#dv_RDDG_' + this.questions[i].UniqueNumber).width();
            $('.drill-down-list-itemMessage_'+self.questions[i].UniqueNumber).css('width',width + 'px');
          }
        }
      }
    }
  }

  ngOnDestroy(){
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  DropDownSelectedValue(event: any, question: Questions,isSearchableDD: boolean = false,curVal: number = -1) {

    let value = event.target.value;
    if (isSearchableDD) {
      value = curVal.toString();
    }

    if (value === "-1") {
      question.isOtherAnswer = false;
      question.selectAnsValue = -1;
      question.AnswerID = 0;
      question.AnswerText = null;
    } else {
      for (let i = 0; i < question.Answers.length; i++) {
        if (value == question.Answers[i].value_id) {
          event.selectdId = 1;
          question.Answers[i].selectdId = 1;
          question.AnswerID = question.Answers[i].ms_id;
          question.selectAnsValue = question.Answers[i].value_id;
          question.AnswerText = question.Answers[i].value_text;
          question.pageto = question.Answers[i].pageto;
          question.otherAnswer = null;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (question.Answers[i].isOther) {
            question.isOtherAnswer = true;
          }
          else {
            question.isOtherAnswer = false;
          }
        }
        else {
          question.Answers[i].ControlAns = null;
          question.Answers[i].selectdId = 0;
        }
      }
    }

    this.UpdateQuestionsData(question);
    //this.ChangeAnswersData.emit(question);
  }

  GetSubQnNumber(): boolean{
    return this.isDisplayQno;
  }

  getPipingTitle(group_no: number): string{
    return this.service.getPiping(group_no);
  }
  getHiddenQuestions(questions:Questions,service: ParticipationDataService)
  {
    if(service.getGroupType().toLowerCase() == "preview" && service.getPreviewData().isShowHiddenQN){
      return true;
    }
    else{
      return (questions.population_type != 2 && questions.population_type != 5 && questions.isCQHide==false);
    }
  }

  setDrillDownValue(event: any, question: Questions, self,curVal: number) {
    self.DropDownSelectedValue(event, question,true,curVal);

    if($('#dv_RDDG_' + question.UniqueNumber).find('input.drill-down-input-'+ question.UniqueNumber)){
      if($('#dv_RDDG_' + question.UniqueNumber).find('input.drill-down-input-'+ question.UniqueNumber).val() == "") {
        $('#dv_RDDG_' + question.UniqueNumber).find('input.drill-down-input-'+ question.UniqueNumber).removeClass('no-search-icon');
      } else {
        $('#dv_RDDG_' + question.UniqueNumber).find('input.drill-down-input-'+ question.UniqueNumber).addClass('no-search-icon');
      }
    }else{
      if($('#dv_' + question.UniqueNumber).find('input.drill-down-input').val() == "") {
        $('#dv_' + question.UniqueNumber).find('input.drill-down-input').removeClass('no-search-icon');
      } else {
        $('#dv_' + question.UniqueNumber).find('input.drill-down-input').addClass('no-search-icon');
      }
    }
  }

  showDDList(event) {
    if ($(event.target).parents().hasClass('showDrillList')) {
      $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      $(event.target).closest('.drill-down-input').attr("aria-expanded","false");
    }else{
      $('.drill-down-search').removeClass('showDrillList');
    $(event.target).closest('.drill-down-search').addClass('showDrillList');
    $(event.target).closest('.drill-down-search').find('.drill-down-input').focus();
    $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
    $(event.target).closest('td').css('z-index', '2');
    }
  }

  selectDDListItem(event, question: Questions) {
    var self = this;
    $(event.target).closest('.drill-down-search').find('.drill-down-input').val('');
    $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
      $(this).html($(this).attr('ogListValue'));
      $(this).show();
      $(this).html(self.highlight($(this).html(), ''));
    });
    let itemText = $(event.target).attr('ogListValue');
    let itemValue = $(event.target).attr('list-value');
    $(event.target).closest('.drill-down-search').find('select').val(itemValue);
    $(event.target).closest('.drill-down-search').find('.drill-down-input').val(itemText);
    $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).closest('td').css('z-index', '0');
    self.checkDrillDown = 1;
    self.setDrillDownValue(event, question, self,itemValue);
  }

  setDDListItem(event, question: Questions) {
    var self = this;
    setTimeout(function () {
      if (self.checkDrillDown == 0 && self.checkDrillDown != undefined) {
        const ddSearchValue = $(event.target).val().toLowerCase();
        // const currentInput = $(this);
        if (ddSearchValue !== '') {
          $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
            $(this).html($(this).attr('ogListValue'));
            if (ddSearchValue === $(this).text().toLowerCase()) {
              $(event.target).val($(this).attr('ogListValue'));
              // $(event.target).closest('.drill-down-search').removeClass('showDrillList');
              $(event.target).closest('td').css('z-index', '0');
              const itemValue = $(this).attr('list-value');
              $(this).closest('.drill-down-search').find('select').val(itemValue);
              self.setDrillDownValue(event, question, self,itemValue);
              return false;
            } else {
              $(event.target).val('');
              $(this).closest('.drill-down-search').find('select').val('0');
              question.AnswerText = null;
              self.setDrillDownValue(event, question, self,-1);
            }
          });
        } else {
          question.AnswerText = null;
          self.setDrillDownValue(event, question, self,-1);
        }
      }
    }, 0);
    // $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).closest('td').css('z-index', '0');
    setTimeout(function () {
      $('.drill-down-list-itemMessage_'+question.UniqueNumber).hide();
    }, 1);
  }

  filterDDSearch(event, question: Questions) {
    var self = this;
    var keyCode = event.keyCode || event.which;
    if(keyCode == 13 || keyCode == undefined){
      event.preventDefault();
      $(event.target).blur();
      setTimeout(function (){
        $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      }, 100);
    }
    setTimeout(function () {
      var keyCode = event.keyCode || event.which;
      if(keyCode !== 9){
        $(event.target).closest('.drill-down-search').addClass('showDrillList');
        if(keyCode == 40){
          event.preventDefault();
          if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'))){
            $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'));
            $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
            $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').addClass('currentActiveDDITem');
            $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
          } else {
            var nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').nextAll('.drill-down-list-item:visible:first');
            if(nextElement.length > 0){
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              nextElement.addClass('currentActiveDDITem');
            } else {
              nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              nextElement.addClass('currentActiveDDITem');
            }
          }

          var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
          var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
          var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
          var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

          if(elementPosWithHt > scrollableDivPosWithHt){
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
          } else if(elementPos < scrollableDivPos) {
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
          }

        } else if(keyCode == 38) {
          event.preventDefault();
          if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'))){
            $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'));
            $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
            $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').addClass('currentActiveDDITem');
            $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
          } else {
            // $(event.target).closest('.drill-down-search').find('select').val(parseInt($(event.target).closest('.drill-down-search').find('select').val()) - 1);
            // $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());

            var prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').prevAll('.drill-down-list-item:visible:first');
            if(prevElement.length > 0){
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              prevElement.addClass('currentActiveDDITem');
            } else {
              prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              prevElement.addClass('currentActiveDDITem');
            }
          }
          var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
          var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
          var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
          var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

          if(elementPosWithHt > scrollableDivPosWithHt){
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
          } else if(elementPos < scrollableDivPos) {
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
          }
        } else {
          $(event.target).closest('td').css('z-index', '2');
          $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
          $(event.target).closest('.drill-down-search').find('select').val('-1');
          const ddSearchValue = $(event.target).val().toLowerCase();
          if (ddSearchValue !== '') {
            var isShowmessage=false;
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
              $(this).html($(this).attr('ogListValue'));
              if ($(this).text().toLowerCase().indexOf(ddSearchValue) !== -1) {
                $(this).show();
                $(this).html(self.highlight($(this).html(), ddSearchValue));
                isShowmessage=true;
              } else {
                $(this).hide();
              }
            });
            if(!isShowmessage){
              $('.drill-down-list-itemMessage_'+question.UniqueNumber).show();
            }else{
              $('.drill-down-list-itemMessage_'+question.UniqueNumber).hide();
            }
            if ($(event.target).closest('.drill-down-search').find('.drill-down-list-item:visible').length === 0) {
              $(event.target).closest('.drill-down-search').removeClass('showDrillList');
              $(event.target).closest('td').css('z-index', '0');
            } else {
              $(event.target).closest('.drill-down-search').addClass('showDrillList');
              $(event.target).closest('td').css('z-index', '2');
            }
          } else {
            $('.drill-down-list-itemMessage_'+question.UniqueNumber).hide();
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
              $(this).html($(this).attr('ogListValue'));
            });
          }
          if($(event.target).val() != self.prevValue){
            self.checkDrillDown = 0;
          } else {
            self.checkDrillDown = 1;
          }
        }
      } else {
        $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      }
    }, 1);
  }

  setPrevValue(event){
    this.prevValue = $(event.target).val();
  }

  highlight(s, search) {
    return s.replace(new RegExp(
      search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'
    ), '<b>$&</b>');
  }

  setRddColWidth(){
    let elemid = '#dv_' + this.firstQuestion.UniqueNumber;

      let fieldWidth = $(elemid).find('.fieldset-wrapper').outerWidth();

      this.mainQuestionWidth = this.matrix.subq_col_width;
      this.mainQuestionWidth = fieldWidth * (this.mainQuestionWidth/100);
      this.subQuestionWidth = this.group.colwidth;
      this.subQuestionWidth = fieldWidth * (this.subQuestionWidth/100) - 25; //25 is the padding for td
      this.totalWidth = this.mainQuestionWidth + this.subQuestionWidth;


      if (this.mainQuestionWidth == 0) {
        this.mainQuestionWidth = fieldWidth/2;
      }

      if (this.subQuestionWidth == 0) {
        this.subQuestionWidth = fieldWidth/2 - 30; //30 is the padding for td
      }

      if (this.totalWidth === 0) {
        this.totalWidth = fieldWidth;
      }

      $(elemid).find('.matrixTitleTd').width(this.mainQuestionWidth - 30);
      this.changeDetect.detectChanges();
  }

  nextQuestion(event) {
    if (this.isNewParticipation && (this.surveyFormat == 1 || this.surveyFormat == 2) && this.dropDownlength == 1 && this.service.isAutoScroll) {
      // var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
      // if (nextbtnLength > 0) {
      //   var elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
      //   $('html,body').animate({
      //     scrollTop: (elemPosition - $(window).height() / 3)
      //   }, 400);
      // } else {
      //   var scrollVal = $('.tblPageFooter').offset().top;
      //   $('html,body').animate({
      //     scrollTop: scrollVal
      //   }, 400);
      // }
      // $(event).closest('.main-ques-cont').find('.ques-response-btn-div').hide();

      this.service.gotoNextQuestion(this.questions[0],event);
    }
  }

  gotoNextQuestion(question: Questions, event: any) {
    this.service.gotoNextQuestion(question, event);
  }

   gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }

  closeDDList(event) {
    if(event.target.value !== "") {
      event.target.value = ""
    }
    $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).attr("aria-expanded","false");
  }

  ngAfterHandle(){
    this.ngCount = 0;
    this.ngAfterViewInit();
  }

  getAnswerPipeMessage(): string{
    return this.service.getAnswerPipeMessage();
  }
}
